import styles from './styles.module.scss';

export default function Publication({ p, deletarMembro }) {
  return (
    <div className={styles.card}>
      <a href={p.url} target='_blank' className={styles.link}>
        Clique aqui para abrir a publicação
      </a>
      <img src={p.image} alt="Imagem da publicação" className={styles.image} />
      <button onClick={() => deletarMembro(p.id)} className={styles.delete}>
        Deletar
      </button>
    </div>
  );
}
